export default __webpack_public_path__ + "static/media/card_3.4b574f8b.svg";